import { Component, Input, OnInit } from '@angular/core';
import { CurrentTenantService } from '../../../../../../../../../../../SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/services/current-tenant.service';
import { DataSourceItemsService } from '../../../../../data-source/data-source-items/services/data-source-items.service';
import { FAKE_TOTALS } from '../../../../data/fake-totals';
import { IBannerTileDefinition } from '../../../../interfaces/tiles/definitions/banner-tile-definition.interface';
import { ITileComponent } from '../../tile-component.interface';
import { resolveSiteAssetUrl } from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvo-bi-banner-tile',
  templateUrl: './banner-tile.component.html',
  styleUrls: ['./banner-tile.component.scss'],
})
export class BannerTileComponent implements ITileComponent, OnInit {
  @Input() tileInstance: IBannerTileDefinition;

  displayNumber: number;
  displayNumberLoaded = false;

  constructor(
    private dataSourceItemsService: DataSourceItemsService,
    private tenantService: CurrentTenantService,
  ) {}

  async ngOnInit() {
    if (this.tileInstance?.displayFeatureTotal) {
      // TODO: Workaround until we can count Tenders properly
      if (this.tileInstance.displayFeatureTotal === 'tenders') {
        this.displayNumber = FAKE_TOTALS[this.tileInstance.displayFeatureTotal];
      } else {
        this.displayNumber = await this.dataSourceItemsService.getCount(
          this.tileInstance.displayFeatureTotal,
        );
      }
    }
  }

  ngAfterViewInit() {
    this.displayNumberLoaded = true;
  }

  get shouldShowCard(): boolean {
    const displayProperties = this.tileInstance?.displayProperties as
      | { noCard?: boolean; isCard?: boolean }
      | undefined;
    if (displayProperties?.noCard !== undefined) {
      return !displayProperties.noCard;
    }
    if (displayProperties?.isCard !== undefined) {
      return displayProperties.isCard;
    }
    if (this.tileInstance?.noCard !== undefined) {
      return !this.tileInstance.noCard;
    }
    return true;
  }

  get isWhiteBackground(): boolean {
    return !!this.tileInstance?.white;
  }

  get textColor(): string {
    return this.tileInstance?.color ?? (this.isWhiteBackground ? '#000000' : '#ffffff');
  }

  get backgroundColor(): string {
    const provided = this.tileInstance?.backgroundColor ?? this.tileInstance?.background;
    if (provided) {
      return provided;
    }
    return this.getContrastColor(this.textColor);
  }

  private getContrastColor(color: string): string {
    const normalized = (color || '').trim().toLowerCase();
    if (!normalized) {
      return '#ffffff';
    }
    if (normalized === '#000' || normalized === '#000000' || normalized === 'black') {
      return '#ffffff';
    }
    if (normalized === '#fff' || normalized === '#ffffff' || normalized === 'white') {
      return '#000000';
    }

    const hex = normalized.startsWith('#') ? normalized.slice(1) : normalized;
    if (hex.length !== 6 && hex.length !== 3) {
      return '#000000';
    }

    const expand = (value: string) =>
      value
        .split('')
        .map((c) => c + c)
        .join('');
    const fullHex = hex.length === 3 ? expand(hex) : hex;
    const r = parseInt(fullHex.slice(0, 2), 16);
    const g = parseInt(fullHex.slice(2, 4), 16);
    const b = parseInt(fullHex.slice(4, 6), 16);
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }

  get contentImgPath() {
    if (!this.tileInstance?.imgUri) {
      return '';
    }

    return resolveSiteAssetUrl(
      this.tileInstance.imgUri,
      this.tenantService.currentTenantData?.primaryWebUrl ?? '',
    );
  }
}
